import React from "react";
import { odemeTarihiHesapla } from '../../../helpers/odemeTarihi';
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../CustomSingleSelect";
import { storeActivityIndicator, storeFastFirm } from "../../../redux/reducers/authSlice";
import { Helpers } from "../../../helpers/Helpers";
import { GetActiveCurrencyConversions } from "../../../models/response/currencyConversion/GetActiveCurrencyConversions";
import { CurrencyConversionService } from "../../../services/CurrencyConversionService";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAddress } from "../../../models/response/company/GetCompanyByIdResponse";
import { CompanyService } from "../../../services/CompanyService";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import { ConstantService } from "../../../services/ConstantService";

interface Props {
    generalInformationRef: any
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCurrentCompany: CustomSingleSelectModel | undefined
    setSelectedCurrentCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedAddressType: CustomSingleSelectModel | undefined
    setSelectedAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    setSelectedPaymentType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedMaturityPeriod: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setPaymentDate: React.Dispatch<React.SetStateAction<string | undefined>>
    setInvoiceDate: React.Dispatch<React.SetStateAction<string | undefined>>
    invoiceDate: string | undefined
    selectedModule: CustomSingleSelectModel | undefined
    addressText: string | undefined
    selectedOperationType: CustomSingleSelectModel | undefined
    setSelectedModule: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedMaturityPeriod: CustomSingleSelectModel | undefined
    selectedInvoiceCategory: CustomSingleSelectModel | undefined
    setSelectedInvoiceCategory: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCurrencyType: CustomSingleSelectModel | undefined
    setSelectedOperationType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedPaymentType: CustomSingleSelectModel | undefined
    selectedInvoiceStatus: CustomSingleSelectModel | undefined
    setSelectedInvoiceStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setCurrency: React.Dispatch<React.SetStateAction<string | undefined>>
    serialNo: string | undefined
    setSerialNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCurrencyRateType: CustomSingleSelectModel | undefined
    currencyDate: string | undefined
    setCurrencyDate: React.Dispatch<React.SetStateAction<string | undefined>>
    transferDate: string | undefined
    paymentDate: string | undefined
    setSelectedInvoiceType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setTransferDate: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedInvoiceType: CustomSingleSelectModel | undefined
    currency: string | undefined
    setSelectedCurrencyRateType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isSale: boolean
    isPurchase: boolean
    isRefund: boolean
    getCurrency: (_selectedCurrencyType: CustomSingleSelectModel | undefined, _selectedCurrencyRateType: CustomSingleSelectModel | undefined, _currencyDate: string | undefined, _closeLoading: boolean) => Promise<void>
    setIsCustomerWithholding: React.Dispatch<React.SetStateAction<boolean>>
}

const CommonInvoiceGeneralInformation = ({
    generalInformationRef,
    refNo,
    setRefNo,
    selectedCurrentCompany,
    setSelectedCurrentCompany,
    selectedAddressType,
    setSelectedAddressType,
    setAddressText,
    setSelectedPaymentType,
    setSelectedCurrencyType,
    setSelectedMaturityPeriod,
    setPaymentDate,
    setInvoiceDate,
    invoiceDate,
    selectedModule,
    addressText,
    selectedOperationType,
    setSelectedModule,
    selectedMaturityPeriod,
    selectedInvoiceCategory,
    setSelectedInvoiceCategory,
    selectedCurrencyType,
    setSelectedOperationType,
    selectedPaymentType,
    selectedInvoiceStatus,
    setSelectedInvoiceStatus,
    setCurrency,
    serialNo,
    setSerialNo,
    selectedCurrencyRateType,
    currencyDate,
    setCurrencyDate,
    transferDate,
    paymentDate,
    setSelectedInvoiceType,
    setTransferDate,
    currency,
    selectedInvoiceType,
    setSelectedCurrencyRateType,
    isSale,
    isPurchase,
    isRefund,
    getCurrency,
    setIsCustomerWithholding
}: Props) => {
    const dispatch = useDispatch();

    // Odeme sekli Nakit ise odeme tarihi fatura tarihiyle ayni gun (19.10.2026); degilse fatura tarihi + vade.
    // Odeme sekli elle secilince, firmadan otomatik gelince ve fatura tarihi degisince tetiklenir.
    const getPaymentDate = (_selectedMaturityPeriod: CustomSingleSelectModel | undefined, _selectedPaymentType: CustomSingleSelectModel | undefined, _invoiceDate: string | undefined) => {
        setPaymentDate(odemeTarihiHesapla(_selectedPaymentType?.additionalValue1, _selectedMaturityPeriod?.additionalValue1, _invoiceDate));
    }

    const addressTypeSelectHandler = async (addressType: CustomSingleSelectModel | undefined, _companyId: string | undefined = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            if (_companyId && !Helpers.isEmpty(_companyId)) {
                var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_companyId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setIsCustomerWithholding(response.data.isWithholding);

                var _selectedPaymentType = undefined;

                if (response.data.paymentTypeId && response.data.paymentTypeName)
                    _selectedPaymentType = { label: response.data.paymentTypeName, value: response.data.paymentTypeId, additionalValue1: response.data.paymentTypeKey };

                setSelectedPaymentType(_selectedPaymentType);

                if (response.data.invoiceCurrencyTypeId && response.data.invoiceCurrencyTypeName) {
                    var _selectedCurrencyType = { label: response.data.invoiceCurrencyTypeName, value: response.data.invoiceCurrencyTypeId };
                    setSelectedCurrencyType(_selectedCurrencyType);
                    await getCurrency(_selectedCurrencyType, selectedCurrencyRateType, currencyDate, false);
                }
                else {
                    setSelectedCurrencyType(undefined);
                }

                var _selectedMaturityPeriod = undefined

                if (response.data.maturityPeriodId && response.data.maturityPeriodName)
                    _selectedMaturityPeriod = { label: response.data.maturityPeriodName, value: response.data.maturityPeriodId, additionalValue1: response.data.maturityPeriodKey };

                setSelectedMaturityPeriod(_selectedMaturityPeriod);

                getPaymentDate(_selectedMaturityPeriod, _selectedPaymentType, invoiceDate);

                if (response.data.companyAddresses.length > 0) {
                    var companyAddress: GetCompanyByIdResponseCompanyAddress | undefined = undefined;

                    if (addressType && addressType.value)
                        companyAddress = response.data.companyAddresses.find(x => x.addressTypeId == addressType.value);

                    if (!companyAddress)
                        companyAddress = response.data.companyAddresses.find(x => x.isDefault);

                    if (!companyAddress)
                        companyAddress = response.data.companyAddresses[0];

                    if (companyAddress) {
                        if (companyAddress.addressTypeId && companyAddress.addressTypeName)
                            setSelectedAddressType({ label: companyAddress.addressTypeName, value: companyAddress.addressTypeId });

                        if (companyAddress.addressText)
                            setAddressText(companyAddress.addressText);

                        return;
                    }
                }
            }

            setSelectedAddressType(undefined);
            setAddressText('');
            setSelectedMaturityPeriod(undefined);
            setSelectedCurrencyType(undefined);
            setSelectedPaymentType(undefined)
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={refNo} onChange={(e) => setRefNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Cari Ünvanı</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCurrentCompany}
                                    onChange={(selectedValue) => {
                                        addressTypeSelectHandler(undefined, selectedValue?.value);
                                        setSelectedCurrentCompany(selectedValue);
                                    }}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedCurrentCompany?.value,
                                                isCustomer: true,
                                                isAgency: true,
                                                isSupplier: true,
                                                onSubmit: async (response) => {
                                                    setSelectedCurrentCompany({ label: response.name, value: response.companyId })
                                                }
                                            }))
                                        }
                                    }}
                                    onMenuOpen={[
                                        () => CompanyService.getCompanyList({ isCustomer: true }),
                                        () => CompanyService.getCompanyList({ isAgency: true }),
                                        () => CompanyService.getCompanyList({ isSupplier: true }),
                                    ]}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Adres Türü</label>

                                <CustomSingleSelect
                                    selectedValue={selectedAddressType}
                                    onChange={(selectedValue) => {
                                        if (selectedValue)
                                            addressTypeSelectHandler(selectedValue, selectedCurrentCompany?.value);
                                        else {
                                            setSelectedAddressType(undefined);
                                            setAddressText('');
                                        }
                                    }}
                                    insertable={!selectedCurrentCompany ? undefined : {
                                        tooltipText: 'Seçilmiş olan firmaya Yeni adres tanımlama işlemini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedCurrentCompany?.value,
                                                isJustAddress: true,
                                                isCustomer: true,
                                                isAgency: true,
                                                isSupplier: true,
                                                onSubmit: async (response) => {
                                                    if (response.companyAddresses.length > 0) {
                                                        addressTypeSelectHandler({ label: response.companyAddresses[0].addressTypeName, value: response.companyAddresses[0].addressTypeId }, response.companyId);
                                                    }
                                                }
                                            }))
                                        }
                                    }}
                                    onMenuOpen={selectedCurrentCompany ? () => CompanyService.getCompanyById(selectedCurrentCompany.value) : undefined}
                                    labelName='addressTypeName'
                                    valueName='addressTypeId'
                                    innerPropName="companyAddresses"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Adres</label>

                                <input disabled style={{ border: '1px solid #F1F1F4' }} value={addressText} onChange={(e) => setAddressText(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Modül</label>

                                <CustomSingleSelect
                                    selectedValue={selectedModule}
                                    onChange={setSelectedModule}
                                    onMenuOpen={() => ConstantService.getConstantList('MODULE')}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Operasyon Türü</label>

                                <CustomSingleSelect
                                    selectedValue={selectedOperationType}
                                    onChange={setSelectedOperationType}
                                    onMenuOpen={() => ConstantService.getConstantList('OPERATION_TYPE', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Kategori</label>

                                <CustomSingleSelect
                                    selectedValue={selectedInvoiceCategory}
                                    onChange={setSelectedInvoiceCategory}
                                    onMenuOpen={() => ConstantService.getConstantList(`${(isSale ? 'SALE' : isPurchase ? 'PURCHASE' : isRefund ? 'REFUND' : '')}_CATEGORY`, undefined, undefined)}
                                    insertable={{
                                        onSubmit: { code: `${(isSale ? 'SALE' : isPurchase ? 'PURCHASE' : isRefund ? 'REFUND' : '')}_CATEGORY` }
                                    }}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Fatura Durumu</label>

                                <CustomSingleSelect
                                    selectedValue={selectedInvoiceStatus}
                                    onChange={setSelectedInvoiceStatus}
                                    onMenuOpen={() => ConstantService.getConstantList('INVOICE_STATUS', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Fatura Tarihi</label>

                                <input
                                    style={{ border: '1px solid #F1F1F4' }}
                                    value={invoiceDate}
                                    onChange={(e) => {
                                        setInvoiceDate(e.target.value);
                                        getPaymentDate(selectedMaturityPeriod, selectedPaymentType, e.target.value);
                                    }}
                                    type="date"
                                    className="form-control form-control-solid"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Fatura Seri/No</label>

                                <input style={{ border: '1px solid #F1F1F4' }} value={serialNo} onChange={(e) => setSerialNo(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Ödeme Şekli</label>

                                <CustomSingleSelect
                                    selectedValue={selectedPaymentType}
                                    onChange={(selectedValue) => {
                                        setSelectedPaymentType(selectedValue);
                                        getPaymentDate(selectedMaturityPeriod, selectedValue, invoiceDate);
                                    }}
                                    insertable={{
                                        onSubmit: { code: 'COMPANY_PAYMENT_TYPE' }
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('COMPANY_PAYMENT_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name='additionalValue1'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ödeme Vadesi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedMaturityPeriod}
                                    onChange={(selectedValue) => {
                                        getPaymentDate(selectedValue, selectedPaymentType, invoiceDate);
                                        setSelectedMaturityPeriod(selectedValue);
                                    }}
                                    insertable={{
                                        onSubmit: { code: 'COMPANY_MATURITY_PERIOD' }
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('COMPANY_MATURITY_PERIOD')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Ödeme Tarihi</label>

                                <input disabled style={{ border: '1px solid #F1F1F4' }} value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Döviz Cinsi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCurrencyType}
                                    onChange={(selectedValue) => {
                                        setSelectedCurrencyType(selectedValue);
                                        getCurrency(selectedValue, selectedCurrencyRateType, currencyDate, true);
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                    labelName='additionalValue1'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Kur Tarihi</label>

                                <input
                                    style={{ border: '1px solid #F1F1F4' }}
                                    value={currencyDate}
                                    onChange={(e) => {
                                        setCurrencyDate(e.target.value)
                                        getCurrency(selectedCurrencyType, selectedCurrencyRateType, e.target.value, true);
                                    }}
                                    type="date"
                                    className="form-control form-control-solid"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Kur Tipi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCurrencyRateType}
                                    onChange={(selectedValue) => {
                                        setSelectedCurrencyRateType(selectedValue)
                                        getCurrency(selectedCurrencyType, selectedValue, currencyDate, true);
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('CURRENCY_TYPE', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Kur</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={currency} onChange={(e) => setCurrency(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Fatura Tipi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedInvoiceType}
                                    onChange={setSelectedInvoiceType}
                                    onMenuOpen={() => ConstantService.getConstantList('INVOICE_TYPE', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Transfer Tarihi</label>

                                <input disabled style={{ border: '1px solid #F1F1F4' }} value={transferDate} onChange={(e) => setTransferDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default CommonInvoiceGeneralInformation;